/**
 * Synonymes recherche storefront — fallback sans API Search & Discovery.
 * Mappe requêtes → terme canonique ou collection.
 */
(function () {
  'use strict';

  var GROUPS = [
    ['casque', 'headset', 'écouteurs gaming', 'casque gamer', 'casque ps5'],
    ['manette', 'controller', 'manette switch', 'manette ps5', 'manette xbox'],
    ['coque', 'coque iphone', 'coque samsung', 'coque téléphone', 'protection téléphone'],
    ['déco', 'deco', 'déco geek', 'décoration gaming', 'poster gaming', 'ambiance gaming'],
    ['snack', 'box snack', 'bonbons', 'goûter', 'snack japonais', 'snack coréen'],
    ['fivem', 'mod fivem', 'mods fivem', 'ressource fivem', 'serveur fivem'],
    ['mlo', 'mapping fivem', 'ymap', 'intérieur fivem', 'map fivem'],
    ['script fivem', 'scripts fivem', 'esx', 'qbcore', 'ressource rp'],
    ['pc gamer', 'pc gaming', 'ordinateur gamer', 'config pc', 'tour gaming'],
    ['jeux pc', 'clé steam', 'cles steam', 'clé jeu', 'jeux vidéo', 'game key', 'steam key', 'epic games key'],
    ['cadeau', 'cadeau geek', 'idée cadeau', 'gift geek', 'cadeau gamer'],
    ['lampes', 'lampe résine', 'veilleuse', 'déco led', 'éclairage gaming'],
    ['streetwear', 'vêtement geek', 'sweat geek', 't-shirt gaming', 'wayne outfitters'],
    ['gothamdev', 'développement web', 'création site', 'bot discord', 'service dev'],
    ['console', 'console portable', 'rétrogaming', 'miyoo', 'ayaneo'],
  ];

  var REDIRECTS = {
    fivem: '/collections/mods-fivem-legeekshop',
    'mod fivem': '/collections/mods-fivem-legeekshop',
    'mods fivem': '/collections/mods-fivem-legeekshop',
    mlo: '/collections/mapping-fivem-cartes-et-mods-de-qualite-pour-serveurs',
    'mapping fivem': '/collections/mapping-fivem-cartes-et-mods-de-qualite-pour-serveurs',
    snack: '/collections/box-snack-international-voyage',
    deco: '/collections/decoration-style-geek-ambiance-maison',
    'déco': '/collections/decoration-style-geek-ambiance-maison',
    coque: '/collections/smartphones-ecouteurs-accessoires-tech-mobile',
    casque: '/collections/consoles-et-accessoires-gaming',
    pc: '/collections/pc-by-gothamdev',
    'pc gamer': '/collections/pc-by-gothamdev',
    'jeux pc': '/collections/jeux-video',
    'clé steam': '/collections/jeux-video',
    'cles steam': '/collections/jeux-video',
    'jeux vidéo': '/collections/jeux-video',
    'steam key': '/collections/jeux-video',
    nouveaute: '/collections/nouveautes-exclusivites-premium',
    'nouveauté': '/collections/nouveautes-exclusivites-premium',
    esx: '/collections/scripts-fivem-mods-et-outils-essentiels-pour-votre-serveur',
    qbcore: '/collections/scripts-fivem-mods-et-outils-essentiels-pour-votre-serveur',
  };

  var canonMap = Object.create(null);
  GROUPS.forEach(function (group) {
    var canon = group[0];
    group.forEach(function (term) {
      canonMap[norm(term)] = canon;
    });
  });

  function norm(s) {
    return String(s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function resolveQuery(raw) {
    var n = norm(raw);
    if (!n) return { q: raw };
    if (REDIRECTS[n] || REDIRECTS[raw.toLowerCase().trim()]) {
      return { redirect: REDIRECTS[n] || REDIRECTS[raw.toLowerCase().trim()] };
    }
    if (canonMap[n] && canonMap[n] !== n) {
      return { q: canonMap[n] };
    }
    // match exact synonym as whole query only
    return { q: raw };
  }

  function onSubmit(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var input = form.querySelector('input[name="q"], input[type="search"]');
    if (!input) return;
    var resolved = resolveQuery(input.value);
    if (resolved.redirect) {
      e.preventDefault();
      window.location.assign(resolved.redirect);
      return;
    }
    if (resolved.q && resolved.q !== input.value) {
      input.value = resolved.q;
    }
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      var action = (form.getAttribute('action') || '').toLowerCase();
      if (action.indexOf('/search') === -1 && form.id !== 'predictive-search-form') return;
      onSubmit(e);
    },
    true,
  );
})();
